<template>
<div class='slide slide--resource'>
  <div class='slide_label body-four-light'>
    {{ activity.label || $tc('resource') }}
  </div>

  <h2 class='slide_headline h-two-light'>
    {{ activity.headline }}
  </h2>

  <div
    v-if='activity.subheadline'
    class='slide_subheadline body-one-light'
  >
    {{ activity.subheadline }}
  </div>

  <a
    ref='link'
    class='slide_cta button-one-light'
    :href='link_href'
    target='_blank'
    @click='resourceClick'
  >
    {{ activity.link.title }}
  </a>
</div>
</template>

<script>
import CommonMixin from './common-mixin'

export default {
  mixins: [CommonMixin],

  computed: {
    link_href() {
      const link = this.activity.link.href
      if ( link.match(/pdf$/) || link.match(/docx/) ) {
        if (link.match(/^http:\/\/files.thebigknow.com/)) {
          return link.replace('http://files.thebigknow.com/', 'https://s3.amazonaws.com/files.thebigknow.com/')
        }
        if (link.match(/^http:\/\/s3.amazonaws.com\/files.thebigknow.com/)) {
          return link.replace('http://s3.amazonaws.com/files.thebigknow.com/', 'https://s3.amazonaws.com/files.thebigknow.com/')
        }
        return link
      } else {
        return link
      }
    }
  },

  methods: {
    resourceClick() {
      this.updateResult('clicked')

      if (typeof (dataLayer) !== 'undefined') {
        const destination = this.activity.link.href.search(window.location.hostname) > 0
          ? 'internal'
          : 'external'

        const event = {
          event:                'resourceClick',
          pageCategory:         'resourceSlide',
          resourceTitle:        this.activity.headline,
          resourceSubTitle:     this.activity.link ? this.activity.link.title : this.activity.cta,
          resourceID:           this.activity.id,
          resourceURL:          this.activity.link.href,
          resourceDestination:  destination
        }

        dataLayer.push(event)
      }
    }
  }
}
</script>

<style lang='sass' scoped>
// @import './resource-v1'
</style>
